import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

export default function ProtectedRoute({ children }) {
  const user = useAuthStore((s) => s.user);
  const checkAuth = useAuthStore((s) => s.checkAuth);
  const location = useLocation();
  const [state, setState] = useState(user ? "ok" : "checking");

  useEffect(() => {
    // If returning from OAuth callback, AuthCallback handles the exchange
    if (window.location.hash?.includes("session_id=")) {
      setState("ok");
      return;
    }
    if (user) {
      setState("ok");
      // refresh in background
      checkAuth();
      return;
    }
    checkAuth().then((u) => setState(u ? "ok" : "no"));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // If the background checkAuth() nulled the user (expired token + refresh
  // failed), redirect to the login page and preserve where they were headed.
  // The Login page reads `?next=` and routes there after auth succeeds.
  if (state === "ok" && !user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace state={{ from: location, reason: "session_expired" }} />;
  }

  if (state === "checking") {
    return (
      <div className="min-h-screen grid place-items-center bg-canvas">
        <div className="text-ink-muted text-sm">Loading…</div>
      </div>
    );
  }
  if (state === "no") {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace state={{ from: location }} />;
  }
  return children;
}
